module.exports = __webpack_public_path__ + "img/cloud-upload.21365abf.svg";